import React from 'react';
import { formatTemperature, getWeatherIconUrl, getWeatherEmoji } from '../services/weatherService';

const Forecast = ({ forecast }) => {
  if (!forecast || !forecast.forecast) return null;

  const { forecast: forecastList, city, country } = forecast;

  // Group forecast by day and take the first forecast for each day
  const dailyForecast = forecastList.reduce((acc, item) => {
    const date = new Date(item.date).toDateString();
    if (!acc[date]) {
      acc[date] = item;
    }
    return acc;
  }, {});

  const forecastDays = Object.values(dailyForecast).slice(0, 5); // Take first 5 days

  return (
    <div className="forecast">
      <h3 className="forecast-title">
        🌤️ 5-Day Forecast for {city}, {country}
      </h3>
      
      <div className="forecast-list">
        {forecastDays.map((day, index) => (
          <div key={index} className="forecast-item">
            <div className="forecast-date">
              {new Date(day.date).toLocaleDateString('en-US', {
                weekday: 'short',
                month: 'short',
                day: 'numeric'
              })}
            </div>
            
            <div style={{ margin: '0.5rem 0' }}>
              <img 
                src={getWeatherIconUrl(day.icon)} 
                alt={day.description}
                style={{ width: '50px', height: '50px' }}
              />
            </div>
            
            <div className="forecast-temp">
              {formatTemperature(day.temperature)}
            </div>
            
            <div className="forecast-desc">
              {getWeatherEmoji(day.description)} {day.description}
            </div>
            
            <div style={{ 
              fontSize: '0.8rem', 
              color: '#666', 
              marginTop: '0.5rem' 
            }}>
              Feels like {formatTemperature(day.feels_like)}
            </div>
            
            <div style={{ 
              fontSize: '0.8rem', 
              color: '#666', 
              marginTop: '0.25rem' 
            }}>
              💧 {day.humidity}% | 💨 {Math.round(day.wind_speed * 3.6)} km/h
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Forecast;
